import { isMacOs } from "react-device-detect";
import { app, nativeWindow, tray, webContents } from "@todesktop/client-core";

const MENUBAR_WINDOW_IDX = 0;
const MAIN_WINDOW_IDX = 1;

const openLinkInAppWindowWithTitleBarHidden = async (url: string) => {
    if (window.todesktop) {
        const winRef = await nativeWindow.create({
            titleBarStyle: "hidden",
            width: 1080,
            height: 720,
        });
        await webContents.loadURL({ ref: winRef }, url);
    }
};

const hideMainWindow = async () => {
    if (window.todesktop) {
        const allWindows = await nativeWindow.getAllWindows();
        await nativeWindow.hide({ ref: allWindows[MAIN_WINDOW_IDX] });
    }
};

const showMainWindow = async (url?: string) => {
    if (window.todesktop) {
        const allWindows = await nativeWindow.getAllWindows();
        const mainWindowRef = allWindows[MAIN_WINDOW_IDX];
        await nativeWindow.show({ ref: mainWindowRef });
        if (url) {
            await webContents.loadURL({ ref: mainWindowRef }, url);
        }
        await nativeWindow.focus();
    }
};

const hideMenubarWindow = async () => {
    if (window.todesktop) {
        const allWindows = await nativeWindow.getAllWindows();
        await nativeWindow.hide({ ref: allWindows[MENUBAR_WINDOW_IDX] });
    }
};

const showMenubarWindow = async () => {
    if (window.todesktop) {
        const allWindows = await nativeWindow.getAllWindows();
        await nativeWindow.show({ ref: allWindows[MENUBAR_WINDOW_IDX] });
    }
};

const reloadMenubarWindow = async () => {
    if (window.todesktop) {
        const allWindows = await nativeWindow.getAllWindows();
        await nativeWindow.reload({ ref: allWindows[MENUBAR_WINDOW_IDX] });
    }
};

const updateTrayTitle = (title: string) => {
    if (window.todesktop && isMacOs) {
        tray.setTitle(title);
    }
};

const removeTrayTitle = () => {
    if (window.todesktop && isMacOs) {
        tray.destroy();
    }
};

const getAppVersion = (): string => {
    if (window.todesktop) {
        return app.getVersion();
    }
    return "";
};

const doesCurrentVersionMeetRequirement = (requiredVersion: string) => {
    if (window.todesktop) {
        const currVersion = getAppVersion(); // e.g. "1.4.0"
        const splitCurrVer = currVersion.split("."); // e.g. ["1", "4", "0"]
        const splitReqVer = requiredVersion.split(".");

        return (
            Number(splitCurrVer[0]) >= Number(splitReqVer[0]) &&
            Number(splitCurrVer[1]) >= Number(splitReqVer[1]) &&
            Number(splitCurrVer[2]) >= Number(splitReqVer[2])
        );
    }
    return false;
};

export {
    doesCurrentVersionMeetRequirement,
    getAppVersion,
    hideMainWindow,
    hideMenubarWindow,
    openLinkInAppWindowWithTitleBarHidden,
    reloadMenubarWindow,
    removeTrayTitle,
    showMainWindow,
    showMenubarWindow,
    updateTrayTitle,
};
